import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const AlignVerticalJustifyCenter: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { width: '14', height: '6', x: '5', y: '16', rx: '2' }],
    ['rect', { width: '10', height: '6', x: '7', y: '2', rx: '2' }],
    ['path', { d: 'M2 12h20' }],
  ],
];

export default AlignVerticalJustifyCenter;
